import { queryOptions, useQuery } from '@tanstack/react-query';

import {
  dashboardInstancesQueryKey,
  fetchDashboardInstances,
  fetchPageDashboards,
  pageDashboardsQueryKey,
} from '../../api/portalGateway/dashboard';

export function pageDashboardsQueryOptions(
  sourcePageId: string,
  options?: { enabled?: boolean }
) {
  return queryOptions({
    queryKey: pageDashboardsQueryKey(sourcePageId),
    queryFn: fetchPageDashboards,
    enabled: (options?.enabled ?? true) && sourcePageId.length > 0,
  });
}

export function usePageDashboardsQuery(
  sourcePageId: string,
  options?: { enabled?: boolean }
) {
  return useQuery(pageDashboardsQueryOptions(sourcePageId, options));
}

export function dashboardInstancesQueryOptions(
  sourcePageId: string,
  options?: { enabled?: boolean }
) {
  return queryOptions({
    queryKey: dashboardInstancesQueryKey(sourcePageId),
    queryFn: () => fetchDashboardInstances(sourcePageId),
    enabled: (options?.enabled ?? true) && sourcePageId.length > 0,
  });
}

export function useDashboardInstancesQuery(
  sourcePageId: string,
  options?: { enabled?: boolean }
) {
  return useQuery(dashboardInstancesQueryOptions(sourcePageId, options));
}
